import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';
// Location
export const StudentState = {
    school_id: null,
};

export const StudentSchema = Yup.object().shape({
    school_id: Yup.number().required(),
});

export const StudentFormFields = [
    { name: "school_id", title: "School", required: true, type: VALUE_TYPES.SELECT, options: [], apiRequired: true, displayKey: "name", itemValue: "id" }
];